import { Injectable } from '@angular/core';
import { Accord } from 'src/app/modules/shared/models/accord';
import { DrivePlanStore } from '../models/drive-plan';
import { ActiveFilter } from '../models/filter';

@Injectable({
  providedIn: 'root'
})
export class DrivePlanStoreService {

  accords: Accord[];
  activeFilter: ActiveFilter;
  drivePlanCached: DrivePlanStore[];
  prevDrivePlanCached: DrivePlanStore[];
  activeCategories: string[] = [];

  constructor() {
    this.accords = [];
    this.drivePlanCached = [];
    this.prevDrivePlanCached = [];
    this.activeFilter = {
      status: 'All'
    };
  }
}
